﻿namespace WebPortal.WebPortalTour.Default {
    export class TourDefaultController extends WebPortalTour.TourController {
        protected getGermanSteps(): any[] {
            return (
                [
                    {
                        element: "#navigation_li_starttour",
                        title: "Willkommen beim RMS Web Portal",
                        content: "Mit dieser Tour möchten wir Ihnen die wichtigsten Punkte kurz zeigen.<br />"
                        + "Die Tour kann beliebig oft neu gestartet werden.<br /><br />"
                        + "Weitere Informationen stehen ebenfalls in den FAQ und im ChangeLog für Sie bereit.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_lbt_join_session",
                        title: "Join Session",
                        content: "Ein anderer RMS User kann seine Session mit Ihnen teilen.<br /><br />"
                        + "Hier geben Sie die dazu notwendige SessionID ein, die Ihnen der andere RMS User mitgeteilt hat.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_lbt_file_transfer",
                        title: "File Transfer",
                        content: "Mit dem File Transfer können Sie Dateien und Ordner von Ihrem Arbeitsgerät auf Ihre RMS Shares hoch- und herunterladen.<br /><br />"
                        + "Der Dateiaustausch zwischen RMS Share und Zielsystem erfolgt im Rahmen der verwendeten Management Applikation.<br />"
                        + "Die RMS Shares sind auf der RMS Jumpstation (RJS) als Laufwerke eingebunden.<br /><br />"
                        + "Der File Transfer wird in einem neuen Browser Tab geöffnet.<br /><br />"
                        + "Limiten und weitere Informationen können den FAQ entnommen werden.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_account_information",
                        title: "Account Information",
                        content: "Hier sehen Sie verschiedene Informationen zu Ihrem Account.<br /><br />"
                        + "<strong>Account: </strong><br />"
                        + "Ihre bei RMS gespeicherten persönlichen Angaben.<br />"
                        + "Hier können Sie Ihr RMS Passwort ändern.<br /><br />"
                        + "<strong>Access Groups / Contacts:</strong><br />"
                        + "Hier sehen Sie die Access Groups, für die Sie berechtigt sind.<br />"
                        + "Haben Sie Fragen zu RMS sehen Sie bei jeder Access Group den dafür zuständigen Kontakt.<br /><br />"
                        + "<strong>Access Requests:</strong><br />"
                        + "In diesem Bereich sehen Sie Ihre beantragten Zugriffe, die noch nicht bearbeitet wurden.<br /><br />"
                        + "<strong>Settings: </strong><br />"
                        + "Hier können Sie persönliche Einstellungen wählen:"
                        + "<ul>"
                        + "<li>Second Authentication Method (SMS oder Mobile ID)</li>"
                        + "<li>Tastaturlayout (Standard Deutsch- Schweiz)</li>"
                        + "<li>Startseite (Search, Bookmark, History)</li>"
                        + "</ul>",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_notification_center",
                        title: "Notification",
                        content: "Hier werden bei Bedarf Informationen zu RMS angezeigt.<br /><br />"
                        + "Zum Beispiel eine Ankündigung eines RMS Wartungsfensters oder einer bestehenden Störung einer RMS Komponente.<br /><br />"
                        + "Klicken Sie auf <strong>Notification</strong> um alle vorhandenen Informationen (erneut) anzuzeigen.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_feedback",
                        title: "Feedback",
                        content: "Haben Sie ein Feedback zu RMS?<br /><br />"
                        + "Hier können Sie Anregungen oder auch Wünsche an das Center of Competence REMAS senden.<br /><br />"
                        + "Haben Sie Fragen zur Benutzung, wenden Sie sich bitte an Ihren Kontakt.<br /> "
                        + "Siehe <strong>Contact & Privacy -> Contact</strong> oder <strong>Account Information -> Access Groups / Contacts</strong>",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_logoff",
                        title: "Log off",
                        content: "Hier können Sie sich vom RMS Web Portal abmelden.<br />"
                        + "Wird dieses Fenster geschlossen, werden auch alle weiteren REMAS Session Fenster geschlossen!",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#li_customersearch",
                        title: "Search",
                        content: "Im Search Tab suchen Sie nach Kunden und deren Zielsystemen, für die Sie berechtigt sind.<br /><br />"
                        + "Haben Sie den gewünschte Kunden gefunden, doppelklicken Sie auf den Kundennamen.<br />"
                        + "Es wird ein neuer RMS Browser Tab geöffnet. Sie sehen darin alle für Sie berechtigten Zielsysteme dieses Kunden.",
                        placement: "bottom"
                    }
                    ,
                    {
                        element: "#body_li_bookmark",
                        title: "Favorites",
                        content: "Im Favorites Tab sehen Sie alle Kunden, die Sie aus der Customer View als Favorites markiert haben.<br />"
                        + "In der RMS Session Customer View können Sie Ihre Favorites bei Bedarf auch wieder löschen.",
                        placement: "bottom"
                    }
                    ,
                    {
                        element: "#body_li_history",
                        title: "History",
                        content: "Im History Tab werden alle Kunden aufgeführt, zu denen Sie kürzlich eine Verbindung aufgebaut hatten.",
                        placement: "bottom"
                    }
                    ,
                    {
                        element: "#th_Additional",
                        title: "Search Results - Additional",
                        content: "In der Spalte Additional werden zu jedem gefundenen Kunden weitere Informationen durch Symbole angezeigt.<br /><br />"
                        + "Dies können zum Beispiel sein:"
                        + "<ul>"
                        + "<li>Only CH-based access allowed</li>"
                        + "<li>Maintenance Reason required</li>"
                        + "<li>Proactive Surveillance required</li>"
                        + "<li>oder eine kundenspezifische Message</li>"
                        + "</ul>",
                        placement: "top"
                    }
                ]
            );
        }

        protected getFrenchSteps(): any[] {
            return (
                [
                    {
                        element: "#navigation_li_starttour",
                        title: "Bienvenue au RMS Web Portal",
                        content: "Ce Tour est destiné à vous présenter brièvement les points principaux.<br />"
                        + "Le Tour peut être démarré aussi souvent que souhaité.<br /><br />"
                        + "Des informations supplémentaires sont également à votre disposition dans le FAQ et dans le ChangeLog.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_lbt_join_session",
                        title: "Join Session",
                        content: "Un autre utilisateur de RMS peut partager sa Session avec vous.<br /><br />"
                        + "Indiquez ici le SessionID nécessaire que l’autre utilisateur de RMS vous a communiqué.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_lbt_file_transfer",
                        title: "File Transfer",
                        content: "Le File Transfer vous permet de télécharger des fichiers et des dossiers sur vos RMS Shares depuis votre outil de travail et inversement.<br /><br />"
                        + "L’échange de fichiers entre RMS Share et le système cible se produit dans le cadre de l’application de management utilisée.<br />"
                        + "Les RMS Shares sont intégrés à la RMS Jumpstation (RJS) sous forme de lecteurs.<br /><br />"
                        + "Le File Transfer s’ouvre dans un nouvel onglet du navigateur.<br /><br />"
                        + "Les restrictions d'utilisation et les informations supplémentaires peuvent être consultées dans les FAQ.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_account_information",
                        title: "Account Information",
                        content: "Vous voyez ici les différentes informations concernant votre Account.<br /><br />"
                        + "<strong>Account: </strong><br />"
                        + "Vos données personnelles enregistrées sur RMS.<br />"
                        + "Vous pouvez modifier ici votre mot de passe RMS.<br /><br />"
                        + "<strong>Access Groups / Contacts:</strong><br />"
                        + "Vous voyez ici les Access Groups pour lesquels vous avez une autorisation.<br />"
                        + "Si vous avez des questions concernant RMS, vous pouvez voir l’interlocuteur compétent dans chaque Access Group.<br /><br />"
                        + "<strong>Access Requests:</strong><br />"
                        + "Dans cette zone, vous pouvez consulter vos accès qui ont fait l’objet d’une demande et qui n’ont pas encore été traités.<br /><br />"
                        + "<strong>Settings: </strong><br />"
                        + "Vous pouvez sélectionner ici des réglages personnels"
                        + "<ul>"
                        + "<li>Second Authentication Method (SMS ou Mobile ID)</li>"
                        + "<li>Disposition du clavier (suisse allemand standard)</li>"
                        + "<li>Page d’accueil (Search, Bookmark, History)</li>"
                        + "</ul>",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_notification_center",
                        title: "Notification",
                        content: "Si nécessaire, des informations concernant RMS apparaissent ici.<br /><br />"
                        + "Par exemple une annonce de fenêtre de maintenance de RMS ou une perturbation d’un composant de RMS.<br /><br />"
                        + "Cliquez sur <strong>Notification</strong> pour afficher (à nouveau) toutes les informations existantes.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_feedback",
                        title: "Feedback",
                        content: "Avez-vous un feedback concernant RMS?<br /><br />"
                        + "Vous pouvez envoyer ici les suggestions ou autres demandes au Center of Competence REMAS.<br /><br />"
                        + "En cas de questions concernant l’utilisation, veuillez vous adresser à votre interlocuteur.<br /> "
                        + "Voir <strong>Contact & Privacy -> Contact</strong> ou <strong>Account Information -> Access Groups / Contacts</strong>",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_logoff",
                        title: "Log off",
                        content: "Cette fonction vous permet de vous déconnecter du RMS  Portal.<br />"
                        + "Si cette fenêtre est fermée, toutes les autres fenêtres de la session REMAS seront également fermées !",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#li_customersearch",
                        title: "Search",
                        content: "L’onglet Search vous permet de rechercher des clients et leurs systèmes cibles, pour lesquels vous êtes autorisé.<br /><br />"
                        + "Lorsque vous avez trouvé le client souhaité, double-cliquez sur le nom du client.<br />"
                        + "Un nouvel onglet RMS s’ouvre. Celui-ci vous montre tous les systèmes cibles de ce client pour lesquels vous possédez une autorisation.",
                        placement: "bottom"
                    }
                    ,
                    {
                        element: "#body_li_bookmark",
                        title: "Favorites",
                        content: "Dans l’onglet Favorites, vous voyez tous les clients que vous avez marqués comme Favorites dans la Customer View.<br />"
                        + "Dans la Customer View de la session RMS, vous pouvez également supprimer vos favoris si nécessaire.",
                        placement: "bottom"
                    }
                    ,
                    {
                        element: "#body_li_history",
                        title: "History",
                        content: "Dans l’onglet History sont indiqués tous les clients avec lesquels vous avez établi récemment une relation.",
                        placement: "bottom"
                    }
                    ,
                    {
                        element: "#th_Additional",
                        title: "Search Results - Additional",
                        content: "Dans la colonne Additional sont affichées, sous forme de symboles, des informations supplémentaires sur chaque client trouvé.<br /><br />"
                        + "Il peut s’agir par exemple de:"
                        + "<ul>"
                        + "<li>Only CH-based access allowed</li>"
                        + "<li>Maintenance Reason required</li>"
                        + "<li>Proactive Surveillance required</li>"
                        + "<li>ou un message propre au client</li>"
                        + "</ul>",
                        placement: "top"
                    }
                ]
            );
        }

        protected getItalianSteps(): any[] {
            return (
                [
                    {
                        element: "#navigation_li_starttour",
                        title: "Benvenuti nel RMS Web Portal",
                        content: "Con questo Tour desideriamo illustrarvi brevemente i punti più importanti.<br />"
                        + "Il Tour può essere riavviato a piacere.<br /><br />"
                        + "Trovate ulteriori informazioni anche nelle FAQ e nel ChangeLog.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_lbt_join_session",
                        title: "Join Session",
                        content: "Un altro utente RMS può condividere la sua Session con voi.<br /><br />"
                        + "Inserire qui la SessionID richiesta, che vi è stata comunicata dall’altro user RMS.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_lbt_file_transfer",
                        title: "File Transfer",
                        content: "Con File Transfer è possibile caricare e scaricare file e cartelle dal proprio terminale di lavoro al proprio RMS Shares.<br /><br />"
                        + "Lo scambio di file tra RMS Share e il sistema di destinazione avviene per mezzo dell’applicazione gestionale utilizzata.<br />"
                        + "I RMS Share sono integrati sulla RMS Jumpstation (RJS) come unità.<br /><br />"
                        + "Il File Transfer viene aperto in una nuova scheda del browser.<br /><br />"
                        + "Limiti e ulteriori informazioni possono essere trovati nelle FAQ.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_account_information",
                        title: "Account Information",
                        content: "Qui compaiono diverse informazioni sul proprio Account.<br /><br />"
                        + "<strong>Account: </strong><br />"
                        + "Il vostri dati personali salvati in RMS.<br />"
                        + "Qui è possibile cambiare la password RMS.<br /><br />"
                        + "<strong>Access Groups / Contacts:</strong><br />"
                        + "Qui sono visualizzati gli Access Groups a cui si è autorizzati ad accedere.<br />"
                        + "Se avete domande su RMS, potete vedere il contatto responsabile per ogni Access Group.<br /><br />"
                        + "<strong>Access Requests:</strong><br />"
                        + "In questo campo sono riportati gli accessi che sono stati richiesti, ma non ancora elaborati.<br /><br />"
                        + "<strong>Settings: </strong><br />"
                        + "Qui è possibile selezionare le proprie impostazioni personali:"
                        + "<ul>"
                        + "<li>Second Authentication Method (SMS o Mobile ID)</li>"
                        + "<li>Layout della tastiera (standard tedesco Svizzera)</li>"
                        + "<li>Pagina iniziale (Search, Bookmark, History)</li>"
                        + "</ul>",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_notification_center",
                        title: "Notification",
                        content: "Qui vengono eventualmente visualizzate informazioni su RMS.<br /><br />"
                        + "Ad esempio, l’avviso di un periodo di manutenzione RMS o del guasto a un componente RMS.<br /><br />"
                        + "Fare clic su <strong>Notification</strong> per visualizzare (nuovamente) tutte le informazioni esistenti.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_feedback",
                        title: "Feedback",
                        content: "Volete lasciare il vostro commento su RMS?<br /><br />"
                        + "Qui puoi inviare indicazioni di suggerimenti o eventuali desideri al Center of Competence REMAS.<br /><br />"
                        + "Per domande sull’utilizzo, rivolgersi al proprio referente.<br /> "
                        + "Vedere <strong>Contact & Privacy -> Contact</strong> o <strong>Account Information -> Access Groups / Contacts</strong>",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_logoff",
                        title: "Log off",
                        content: "Qui è possibile disconnettersi dal RMS Web Portal.<br />"
                        + "Se questa finestra viene chiusa, verranno chiuse anche tutte le altre finestre della sessione REMAS!",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#li_customersearch",
                        title: "Search",
                        content: "Nella scheda Search è possibile cercare i clienti e i loro sistemi di destinazione, per i quali sei autorizzato.<br /><br />"
                        + "Una volta trovato il cliente desiderato, fare doppio clic sul nome del cliente.<br />"
                        + "Si apre una nuova scheda del browser RMS. Qui sono visualizzati tutti i sistemi di destinazione di questo cliente a cui si è autorizzati ad accedere.",
                        placement: "bottom"
                    }
                    ,
                    {
                        element: "#body_li_bookmark",
                        title: "Favorites",
                        content: "Nella scheda Favorites sono visualizzati tutti i clienti che avete selezionato nel Customer View come Favorite.<br />"
                        + "Nella sessione RMS Customer View, puoi anche eliminare i tuoi preferiti se necessario.",
                        placement: "bottom"
                    }
                    ,
                    {
                        element: "#body_li_history",
                        title: "History",
                        content: "Nella scheda History sono riportati tutti i clienti con cui si è stabilito un collegamento di recente.",
                        placement: "bottom"
                    }
                    ,
                    {
                        element: "#th_Additional",
                        title: "Search Results - Additional",
                        content: "Nella colonna Additional sono visualizzate altre informazioni sotto forma di simboli su ogni cliente trovato.<br /><br />"
                        + "Possono essere, ad esempio:"
                        + "<ul>"
                        + "<li>Only CH-based access allowed</li>"
                        + "<li>Maintenance Reason required</li>"
                        + "<li>Proactive Surveillance required</li>"
                        + "<li>o un messaggio specifico del cliente</li>"
                        + "</ul>",
                        placement: "top"
                    }
                ]
            );
        }

        protected getEnglishSteps(): any[] {
            return (
                [
                    {
                        element: "#navigation_li_starttour",
                        title: "Welcome to the RMS Web Portal",
                        content: "On this tour, we would like to briefly show you the most important points.<br />"
                        + "The tour can be restarted any number of times.<br /><br />"
                        + "Further information is also available to you in the FAQ and the ChangeLog.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_lbt_join_session",
                        title: "Join Session",
                        content: "Another RMS user can share their Session with you.<br /><br />"
                        + "For this purpose, enter the required SessionID that the other RMS user has shared with you here.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_lbt_file_transfer",
                        title: "File Transfer",
                        content: "With File Transfer, you can upload and download files and folders from your working device to your RMS Shares.<br /><br />"
                        + "The file exchange between RMS Share and the destination system happens within the management application used.<br />"
                        + "The RMS Shares are integrated on the RMS Jumpstation (RJS) as a drive.<br /><br />"
                        + "The File Transfer is opened in a new browser tab.<br /><br />"
                        + "Limits and further information can be found in the FAQ.",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_account_information",
                        title: "Account Information",
                        content: "Here you can see various information about your Account.<br /><br />"
                        + "<strong>Account: </strong><br />"
                        + "Your personal data saved in RMS.<br />"
                        + "You can change your RMS password here.<br /><br />"
                        + "<strong>Access Groups / Contacts:</strong><br />"
                        + "Here you can see the Access Groups that you have authorisation for.<br />"
                        + "If you have questions about RMS, you can see the responsible contact partner for each Access Group.<br /><br />"
                        + "<strong>Access Requests:</strong><br />"
                        + "In this section, you can see the access requests you have made that are still waiting to be processed.<br /><br />"
                        + "<strong>Settings: </strong><br />"
                        + "You can select your personal settings here:"
                        + "<ul>"
                        + "<li>Second Authentication Method (SMS or Mobile ID)</li>"
                        + "<li>Keyboard layout (Standard Swiss German)</li>"
                        + "<li>Startpage (Search, Bookmark, History)</li>"
                        + "</ul>",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_notification_center",
                        title: "Notification",
                        content: "Information about RMS can be displayed here when required.<br /><br />"
                        + "For example, a RMS maintenance window announcement or existing fault in a RMS component.<br /><br />"
                        + "Click <strong>Notification</strong> to display all available information (again).",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_feedback",
                        title: "Feedback",
                        content: "Do you have any feedback about RMS?<br /><br />"
                        + "You can send suggestions or requests to the Center of Competence REMAS here.<br /><br />"
                        + "If you have any questions relating to use, please get in touch with your contact partner.<br /> "
                        + "See  <strong>Contact & Privacy -> Contact</strong> or <strong>Account Information -> Access Groups / Contacts</strong>",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#navigation_li_logoff",
                        title: "Log off",
                        content: "You can log off the RMS Web Portal here.<br />"
                        + "If this window is closed, all other REMAS session windows will also be closed!",
                        placement: "right"
                    }
                    ,
                    {
                        element: "#li_customersearch",
                        title: "Search",
                        content: "In the Search tab, you search for customers and their target systems for which you are authorised.<br /><br />"
                        + "When you have found the customer you want, double click on the customer name.<br />"
                        + "A new RMS browser tab opens. In it you will see all the customer destination systems that you have authorisation for.",
                        placement: "bottom"
                    }
                    ,
                    {
                        element: "#body_li_bookmark",
                        title: "Favorites",
                        content: "In the Favorites tab you can see all the customers you have marked with a Favorite from the Customer View.<br />"
                        + "You can also delete your Favorites again when required in the RMS Session Customer View.",
                        placement: "bottom"
                    }
                    ,
                    {
                        element: "#body_li_history",
                        title: "History",
                        content: "In the History tab all customers are listed that you have recently set up a connection with.",
                        placement: "bottom"
                    }
                    ,
                    {
                        element: "#th_Additional",
                        title: "Search Results - Additional",
                        content: "In the Additional column further information is indicated by icons for each customer found.<br /><br />"
                        + "For example, this could be:"
                        + "<ul>"
                        + "<li>Only CH-based access allowed</li>"
                        + "<li>Maintenance Reason required</li>"
                        + "<li>Proactive Surveillance required</li>"
                        + "<li>or a customer-specific message</li>"
                        + "</ul>",
                        placement: "top"
                    }
                ]
            );
        }
    }
}